(() => {
  const formatters = new Map();
  const locale = value => value || document.documentElement.lang || 'en';
  const zone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  function format(value, language, mode = 'detail') {
    if (value === null || value === undefined || value === '') return '';
    const source = typeof value === 'string' ? value.trim() : value;
    const calendar = typeof source === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(source);
    // A carrier's timezone-less wall clock is not an absolute instant.
    if (typeof source === 'string' && !calendar && !/(Z|[+-]\d{2}:?\d{2})$/i.test(source)) return '';
    const parsed = new Date(typeof source === 'string' ? source.replace(/([+-]\d{2})(\d{2})$/, '$1:$2') : source);
    if (Number.isNaN(parsed.getTime())) return '';
    const languageCode = locale(language), timeZone = calendar ? 'UTC' : zone();
    const key = `${languageCode}:${timeZone}:${calendar ? 'calendar' : mode}`;
    let formatter = formatters.get(key);
    if (!formatter) {
      const options = calendar
        ? {year:'numeric', month:'short', day:'numeric', timeZone}
        : mode === 'deadline'
          ? {year:'numeric', month:'short', day:'numeric', hour:'numeric', minute:'2-digit', timeZoneName:'short', timeZone}
          : {year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23', timeZoneName:'short', timeZone};
      formatter = new Intl.DateTimeFormat(languageCode, options);
      formatters.set(key, formatter);
    }
    if (calendar || mode === 'deadline') return formatter.format(parsed);
    const fields = Object.fromEntries(formatter.formatToParts(parsed).map(part => [part.type, part.value]));
    return `${fields.year}-${fields.month}-${fields.day} ${fields.hour}:${fields.minute}:${fields.second} ${fields.timeZoneName}`;
  }
  function render(root = document) {
    const times = root.matches?.('time[datetime]') ? [root] : [];
    times.push(...(root.querySelectorAll?.('time[datetime]') || []));
    for (const time of times) {
      const source = time.getAttribute('datetime');
      if (!source || /^\d{4}-\d{2}-\d{2}$/.test(source)) continue;
      const label = format(source, undefined, time.hasAttribute('data-local-deadline') ? 'deadline' : 'detail');
      if (!label) continue;
      if (time.textContent !== label) time.textContent = label;
      time.title = `${locale().startsWith('zh') ? '当地时间' : 'Local time'} · ${zone()}`;
      time.dataset.timeReady = 'true';
      if (time.nextElementSibling?.classList.contains('fl-account__timezone')) time.nextElementSibling.hidden = true;
    }
  }
  window.FrameLuneTime = Object.freeze({format, render, zone});
  render();
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') render(record.target);
      else for (const node of record.addedNodes) if (node.nodeType === 1) render(node);
    }
  }).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['datetime']});
})();
